
var THF = THF || {};
THF.Interface = THF.Interface || {};
(function ($, jQuery) {
    'use strict';

    THF.Interface.ArticleListing = function (options) {

        var defaults = {

            apiConfig: {
                endPoint: '/api/v1/health-hub/articles/',
                pageSize: 9,
                tag: ''
            },

            currentPage: 0,
            articleHomePageUrl: "",
            selectors: {
                //Module Parent
                parentElem: '.category-article-list',
                tileRow: '.tile-container-row',
                btnLoadMore: '.btn-load-more',

                articleTile: '.article-tile-featured',
                serviceTile: '.hh-service-tile',

                pagination: '.pagination',
                paginationProgress: '.pagination-process-bar .inner',
                currentlyShowing: '.pagination .currently-showing',
                totalResults: '.pagination .total-results'
            },

        };

        options = $.extend(true, {}, defaults, options);


        /**********************************
         // Declare DOM elements
         **********************************/
        var parentElem = $(options.selectors.parentElem);
        var $tileRow = $parentElem(options.selectors.tileRow);
        var $btnLoadMore = $parentElem(options.selectors.btnLoadMore);

        var $pagination = $parentElem(options.selectors.pagination);
        var $paginationProgress = $parentElem(options.selectors.paginationProgress);
        var $currentlyShowing = $parentElem(options.selectors.currentlyShowing);
        var $totalResults = $parentElem(options.selectors.totalResults);

        var catId = parentElem.data('category-id');


        /**********************************
         // Helper function to return a jQuery object, which is a child of 'parentElem'
         **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }

        /**********************************
         // Template Generators
         **********************************/
        function getArticleTile(articleObj) {
            var imgBlock = '';
            if (articleObj.image_lg) {
            var tagLink = `${options.articleHomePageUrl}?tag=${articleObj.tag}`;
                imgBlock =
                    '           <div class="img-block">\n' +
                    '               <picture>\n' +
                    '                   <source srcset="' + articleObj.image_lg + '" media="(min-width: 993px)">\n' +
                    '                   <img srcset="' + articleObj.image_xs + '" alt="' + articleObj.image_alt + '">\n' +
                    '               </picture>\n' +
                    '               <a class="label tag-link" href="' + tagLink + '"> ' + articleObj.tag + ' </a>\n' +
                    '           </div>\n';
            }

            var articleTile =
                '<div class="col-xs-12 col-md-4" style="display: none;">\n' +
                '    <div class="article-tile-featured">\n' +
                            imgBlock +
                '           <div class="content-block">\n' +
                '               <p class="title">' + articleObj.title + '</p>\n' +
                '               <p class="desc">' + articleObj.description + '</p>\n' +
                '               <div class="link-row">\n' +
                '                   <div class="author">\n' +
                '                       <div class="author-img">\n' +
                '                           <img src="' + articleObj.author.image_url + '" alt="' + articleObj.author.name + '">\n' +
                '                       </div>\n' +
                '                       <p class="author-name">' + articleObj.author.name + '</p>\n' +
                '                   </div>\n' +
                '                   <a class="link stretched-link" href="' + articleObj.link + '" target="' + articleObj.navigationInNewTab+'" >\n' +
                '                       <span class="txt">Read more</span>\n' +
                '                       <svg class="icon icon-arrow-right" preserveAspectRatio="xMidYMid meet"><use xlink:href="/static/svg/sprite.svg#ui-arrow-right"></use></svg>\n' +
                '                   </div>\n' +
                '               </div>\n' +
                '           </div>\n' +
                '        </a>\n' +
                '</div>';

            return articleTile;
        }

        function getServiceTile(articleObj) {           
            var serviceTile =
                '<div class="col-xs-12 col-md-4" style="display: none;">\n' +
                '    <div class="hh-service-tile">\n' +
                '        <div class="icon-block ' + articleObj.tileBackgroundColour + '">\n' +
                '           ' + articleObj.icon + ' \n' +
                '           <p class="title">' + articleObj.text + '</p>\n' +
                '        </div>\n' +
                '        <div class="content-block">\n' +
                '            <p class="title">' + articleObj.title + '</p>\n' +
                '            <p class="desc">' + articleObj.description + '</p>\n' +
                '            <a class="' + articleObj.buttonStyle + '" href="' + articleObj.link + '" target="' + articleObj.serviceTileNavigation+'" >\n' +
                '               <span class="txt">' + articleObj.link_text +  '</span>' +
                '                ' + articleObj.buttonIcon + '\n' +
                '            </a>\n' +
                '        </div>\n' +
                '    </div>\n' +

                '</div>';

            return serviceTile;
        }

        /**********************************
         // State Management
         **********************************/
        function setErrorState(bool) {

            if (bool === true) {
                parentElem.addClass('error-occurred');
                $btnLoadMore.html('Try again?');
            } else {
                parentElem.removeClass('error-occurred');
                $btnLoadMore.html('Load More');
            }
        }




        function updatePagination(loaded, total) {
            var percentageLoaded = (loaded / total * 100) + '%';
            $paginationProgress.css('width', percentageLoaded);
            $currentlyShowing.html(loaded);
            $totalResults.html(total);

            if (loaded === total) {
                $btnLoadMore.addClass('disabled');
            }
        }


        /**********************************
         // API methods
         **********************************/
        function buildApiUrl(catId, pageSize, pageNumber) {
            var apiUrl = options.apiConfig.endPoint + catId + '/page?pageSize=' + pageSize + '&page=' + pageNumber + '&tag=' + encodeURIComponent(options.apiConfig.tag);
            return apiUrl;
        }


        function fetchPage(pageNumber, loadMoreButtonClicked) {
            var apiUrl = buildApiUrl(catId, options.apiConfig.pageSize, pageNumber);
            $.ajax({
                type: 'GET',
                crossDomain: true,
                dataType: 'JSON',
                url: apiUrl,
            })
                .done(function (response) {
                    appendPage(response.items);
                    setErrorState(false);
                    updatePagination(response.loaded, response.total);
                    initCategoryArticleListTracking();

                    // Track only when 'Load More' button is clicked
                    if (loadMoreButtonClicked) {
                        initLoadMoreTracking(response.loaded, response.total);
                    }
                    
                })

                .fail(function (jqXHR, textStatus, errorThrown) {
                    setErrorState(true);
                });
        }

        /**********************************
         // Rendering
         **********************************/
        function appendPage(pageItems) {
            pageItems.forEach(function (obj) {
                var tileMarkup = null;

                if (obj.type === 'article-tile') {
                    tileMarkup = getArticleTile(obj)
                } else if (obj.type === 'service-tile') {
                    tileMarkup = getServiceTile(obj);
                    window.Obj = obj;
                }

                $tileRow
                    .append(tileMarkup)
                    .children()
                    .delay(150)
                    .fadeIn(350);
            });

            //Increase the page count
            options.currentPage++;

        }

        /**********************************
         // Event binding
         **********************************/
        function bindEvents() {
            $btnLoadMore.click(function (e) {
                fetchPage(options.currentPage + 1, true);
            });


        }


        /**********************************
       // Load More Button Tracking
       **********************************/
        function initLoadMoreTracking(loaded, total) {
            if (total > 0) {
                var loadedMessage = loaded + ' of ' + total + ' results';
                //console.log(loadedMessage);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'showMore',
                    'results': loadedMessage
                });
            }
        }


        /**********************************
        // Category Article List Tracking
        **********************************/
        function initCategoryArticleListTracking() {

            // Find service Tile 
            var $serviceTiles = $('.category-article-list .hh-service-tile');
            if ($serviceTiles.length > 0) {
                $serviceTiles.each(function () {
                    var current = $(this);
                    /* Find Service Tile that has not binded to click event */
                    var serviceTileButton = current.find('a:not(.bound)');

                    /* Add bound class once the click event is binded to it serviceTileButton */
                    serviceTileButton.addClass('bound').click(function (e) {
                        //e.preventDefault();
                        //console.log('Category Landing Page >> Service Tile clicked.');
                        //console.log($(this).attr('href'));
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'categoryMainCard',
                            'type': 'Service',
                            'pagePath': $(this).attr('href')
                        });
                    });
                });
            }

            // Find service Tile 
            var $articleTiles = $('.category-article-list .article-tile-featured');
            if ($articleTiles.length > 0) {
                $articleTiles.each(function () {
                    /* Find article tile that has not binded to click event */
                    var articleTileButton = $(this).not('.bound');

                    /* Add bound class once the click event is binded to it serviceTileButton */
                    articleTileButton.addClass('bound').click(function (e) {
                        //e.preventDefault();
                        //console.log('Category Landing Page >> Article Tile clicked.');
                        //console.log($(this).attr('href'));
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'categoryMainCard',
                            'type': 'Article',
                            'pagePath': $(this).attr('href')
                        });

                    });
                });
            }
        }

        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {

            // Init
            if (parentElem.length > 0) {
                fetchPage(1, false);
                bindEvents();
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {

        };
    };


})(jQuery, jQuery);


